<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    
    <path d="M175 0H25C11.2 0 0 11.2 0 25v150c0 13.8 11.2 25 25 25h150c13.8 0 25-11.2 25-25V25c0-13.8-11.2-25-25-25zm-13 76.9L138.2 100l23.8 23.1V162h-38.8L100 138.3 76.8 162H38v-38.9L61.8 100 38 76.9V38h38.8L100 61.7 123.2 38H162v38.9z"/>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: 'Pluxee',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 200 200',
    },
  },
};
</script>

<style scoped>
  
</style>